<template>
    <div style="
            display: flex;
            flex-direction: row;
            align-items: center;
            position: fixed;
            bottom: 10px;
            left: 5%;
            z-index: 999;
            width: 90%;
            height: 50px;
            border-radius: 10px;
            padding-left: 10px;
            backdrop-filter: blur(7px);
            isolation: isolate;
            transform: translateZ(0);
            background-color: #ff646446;
        ">
        <span style="font-weight: bold;">Web Siteyi Beğendiniz mi? </span>
        <a href="https://dryyazilim.com.tr/urunler/anaokulu-kurumsal-web-sitesi-22" style="
            margin-left: 10px;
            margin-left: 10px;
            background-color: #ff6464a1;
            padding: 3px;
            border-radius: 7px;
            color: #fff;
            font-size: 0.9rem;
        "> Hemen Satın Alın!</a>
    </div>
</template>
  
<script>

export default {
    name: "BuyNow",

};
</script>
  